import { createContext, useContext } from 'react';

const AuthContext = createContext({ handleLogout: () => null });

export const AuthProvider = AuthContext.Provider;

export const useAuthContext = () => useContext(AuthContext);
